import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../stores/Stores";
import { Button, Select } from "@fluentui/react-components";
import { FlagRegular } from "@fluentui/react-icons";
import styles from "../customerMeetings.module.scss";
import { CustomerMeeting } from "../store/CustomerMeeting";
import { useTranslation } from "../../shared/translation/Translation";
import Loader from "../../shared/loader/Loader";

interface MeetingTypeFormProps {
    meeting?: CustomerMeeting;

    onClose: () => void;
    onSuccess?: () => void;
}

const MeetingTypeForm: React.FC<MeetingTypeFormProps> = observer((props: MeetingTypeFormProps) => {
    const { meetingStore } = useStore();
    const messages = useTranslation();

    const [meetingType, setMeetingType] = useState<number>();

    useEffect(() => {
        if (props.meeting?.urlHash) {
            meetingStore.getMeetingType(props.meeting?.urlHash);
        }
    }, [meetingStore, meetingStore.meeting]);

    useEffect(() => {
        setMeetingType(meetingStore.meetingType.value);
    }, [meetingStore.meetingType]);

    const updateMeetingType = async () => {
        await meetingStore.updateMeetingType({
            urlHash: props.meeting!.urlHash,
            meetingType: meetingType,
        });

        if (meetingStore.updateMeetingRequestStatus.isDone) {
            props.onSuccess!();
        } else if (!meetingStore.updateMeetingRequestStatus.isPending) {
            props.onClose();
        }
    };

    if (meetingStore.getMeetingTypeRequestStatus.isPending) {
        return <Loader />;
    }

    const currentKey =
        meetingStore.meetingOptions.meetingTypeOptionList.find((o) => o.value === meetingType)?.key ?? "";

    return (
        <>
            <div className={styles.meetingTypeDropdownWrapper}>
                <FlagRegular className={styles.meetingTypeIcon} style={{ fontSize: "24px" }} />
                <Select
                    className={styles.meetingTypeDropdown}
                    value={currentKey}
                    onChange={(_, data) => {
                        const opt = meetingStore.meetingOptions.meetingTypeOptionList.find((o) => o.key === data.value);
                        if (opt !== undefined) setMeetingType(opt.value);
                    }}
                >
                    <option value="" disabled>
                        {messages.organizerMeetingTypePrompt.placeholderMeetingType}
                    </option>
                    {meetingStore.meetingOptions.meetingTypeOptionList.map((o) => (
                        <option key={o.key} value={o.key}>
                            {o.key}
                        </option>
                    ))}
                </Select>
            </div>
            <div className={styles.buttonRow}>
                <Button
                    disabled={meetingStore.updateMeetingTypeRequestStatus.isPending}
                    appearance="primary"
                    onClick={updateMeetingType}
                >
                    {messages.updateMeeting.save}
                </Button>
                <Button onClick={props.onClose}>{messages.meetingModals.closeButton}</Button>
            </div>
        </>
    );
});

export default MeetingTypeForm;
